// Maps a sidebar link's path to the read-only fetch its destination page
// performs on mount, so hovering/focusing the link can warm the prefetch
// cache first. Deliberately GET-only — see api/prefetchCache.js.
import { prefetch } from '../api/prefetchCache';
import {
  getMembersByLibrary,
  getPaymentsByLibrary,
  getRefundsByLibrary,
  getFinesByLibrary,
  getIssuesByLibrary,
  getNotificationsByLibrary
} from '../api/api';

// Matched by suffix so the same rule covers /librarian/*, /admin/* and
// /school/* re-uses of the same underlying Librarian pages.
const RULES = [
  { suffix: '/members', resource: 'members', run: (libraryId) => getMembersByLibrary(libraryId) },
  { suffix: '/payments', resource: 'payments', run: (libraryId) => getPaymentsByLibrary(libraryId) },
  {
    // Order matches RefundList.jsx's own fetchData() — [payments, refunds] —
    // so the cached tuple can seed its two setState calls directly.
    suffix: '/refunds',
    resource: 'refunds',
    run: (libraryId) => Promise.all([getPaymentsByLibrary(libraryId), getRefundsByLibrary(libraryId)])
  },
  { suffix: '/fines', resource: 'fines', run: (libraryId) => getFinesByLibrary(libraryId) },
  { suffix: '/issues', resource: 'issues', run: (libraryId) => getIssuesByLibrary(libraryId) },
  { suffix: '/notifications', resource: 'notifications', run: (libraryId) => getNotificationsByLibrary(libraryId) }
];

export function prefetchLinkTarget(path, libraryId) {
  if (!libraryId || !path) return;

  const rule = RULES.find((r) => path.endsWith(r.suffix));
  if (!rule) return;

  // Best-effort warm-up only — a failed prefetch shouldn't surface anywhere;
  // the destination page still does its own real fetch (with its own error
  // handling) when it mounts.
  prefetch(rule.resource, libraryId, () => rule.run(libraryId)).catch(() => {});
}
